/*
 * fn: getCardQuery
 *
 * Creates a React Query fn and key to request a single card.
 *
 */
import { type QueryFunction, type QueryKey } from '@tanstack/react-query'

import { type CardIdType } from '@/defs/card'
import { fetchCard } from '@/utils/apiUtil'

type QueryReturnType = {
  queryFn: QueryFunction<Awaited<ReturnType<typeof fetchCard> | null>, QueryKey>
  queryKey: ['card', CardIdType | false]
}

const queryFn = async (cardId: CardIdType | false) => (cardId === false ? Promise.resolve(null) : fetchCard(cardId))

export const getCardQuery = (cardId: CardIdType | false): QueryReturnType => ({
  queryFn: () => queryFn(cardId),
  queryKey: ['card', cardId],
})
